import courierRules from "@/constants/CourierRules";
import { helpers } from 'vuelidate/lib/validators'

export const checkDimensionRules = ( courierCode , dimension ) => {
    let status = false
    let msg = ''

    if (
        courierRules[courierCode].maxWLH 
        && Number(dimension.width) + Number(dimension.length) + Number(dimension.height)
        > courierRules[courierCode].maxWLH
    ){
        status = true;
        msg = "ขนาดพัสดุรวมกันต้องไม่เกิน " + courierRules[courierCode].maxWLH + " ซม.";
    }else{
        status = false
        msg = ''
    }

    return { status: status , msg: msg }
}

export const checkDimensionWidth = (courierCode) => (value) => !helpers.req(value) || !(value <= 0 || value > courierRules[courierCode].maxSize.width)

export const checkDimensionLength = (courierCode) => (value) => !helpers.req(value) || !(value <= 0 || value > courierRules[courierCode].maxSize.length)

export const checkDimensionHeight = (courierCode) => (value) => !helpers.req(value) || !(value <= 0 || value > courierRules[courierCode].maxSize.height)